<template>
  <div
    v-scroll-lock
    class="animate__animated animate__fadeIn fixed inset-0 gap-4 flex bg-black/50 z-10 overflow-hidden"
    :class="
      position === 'right' ? 'justify-start flex-row-reverse' : 'flex-row'
    "
    @click.self="handleClose"
  >
    <div
      ref="content"
      :class="[
        'animate__animated h-full w-[300px] shadow-xl overflow-hidden',
        position === 'right' ? 'animate__slideInRight' : 'animate__slideInLeft'
      ]"
    >
      <slot />
    </div>

    <div class="pointer-events-none">
      <div
        ref="closeButton"
        :class="[
          'animate__animated animate__slideInDown flex flex-initial p-3 my-4 bg-[#F1F1F1] rounded-xl cursor-pointer pointer-events-auto'
        ]"
        @click="handleClose"
      >
        <BaseIcon icon="cross" class="text-xl" />
      </div>
    </div>
  </div>
</template>

<script>
import * as motion from 'motion'

import BaseIcon from '@/components/Base/BaseIcon.vue'

export default {
  name: 'BaseSidebar',

  components: { BaseIcon },

  props: {
    position: {
      type: String,
      default: 'left',
      validator: value => ['left', 'right'].includes(value)
    }
  },

  methods: {
    handleClose() {
      const el = this.$el

      this.$refs.content.classList.add(
        this.position === 'right'
          ? 'animate__slideOutRight'
          : 'animate__slideOutLeft'
      )
      this.$refs.closeButton.classList.add('animate__slideOutUp')

      motion
        .animate(el, { opacity: 0 }, { duration: 0.3 })
        .finished.then(() => {
          this.$emit('close')
        })
    }
  }
}
</script>
